module.exports = __webpack_public_path__ + "media/images/market-25950491f2205abeb00260c972b237f1.jpg";